import styled from 'styled-components';

const InlineBlock = styled.h3`
  display: grid;
  grid-template-columns: 5fr 1fr;
`;

export default InlineBlock;
